import qs from "qs";
import { RTFSettingsTab } from "../../config/sidebar";
import { getFirstActiveTab } from "../devices/services";

function getSidebarItems() {
  return Object.keys(RTFSettingsTab)
}

export function getTabFromLocation(search: string) {
  if (search) {
    const searchObject = qs.parse(search)
    return { selectedTab: searchObject.tab || '' } as { selectedTab: string }
  }

  return { selectedTab: "" }
}

export function mapSelectedTab(selectedTab: string, hardwareModel: string, softwareVersion: string) {
  const sidebarItems = getSidebarItems() as Array<RTFSettingsTab>
  const finalTab = sidebarItems.filter((item) => item.toLowerCase() === selectedTab.toLowerCase())[0]
  
  return finalTab || getFirstActiveTab(hardwareModel, softwareVersion)
}